export default __webpack_public_path__ + "static/media/RhymesAnimalTales_11.843d6fbc.png";